<template>
    <!-- This component requires you to enable the `group-focus` variant for `boxShadow` utilities. -->
    <span role="checkbox"
          tabindex="0"
          aria-checked="false"
          @click="onClick"
          class="group relative inline-flex items-center justify-center shrink-0 h-5 w-10 cursor-pointer focus:outline-none">
      <!-- On: "bg-indigo-600", Off: "bg-gray-200" -->
        <span aria-hidden="true"
            :class="valueData ? 'bg-' + color : 'bg-gray-200'"
            class="absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"></span>
        <!-- On: "translate-x-5", Off: "translate-x-0" -->
        <span
              aria-hidden="true"
              :class="valueData ? 'translate-x-5' : 'translate-x-0'"
              class="absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow group-focus:ring group-focus:border-blue-300 transition-transform ease-in-out duration-200">
        </span>
        <input v-model="valueData" :name="inputName" type="hidden" />
    </span>
</template>

<script>
    export default {
        name: "toggle",
        emits: ['toggle', 'update:value'],
        compatConfig: { COMPONENT_V_MODEL: false, ATTR_FALSE_VALUE: false },
        props: {
            value: {
                Type: Boolean,
                default: false,
            },
            name: {
                Type: String,
                default: 'toggle',
            },
            color: {
                type: String,
                default: 'blue-600',
            }
        },
        data() {
            return {
                valueData: this.value
            }
        },
        methods: {
            onClick(event){
                this.$data.valueData = !this.$data.valueData
                this.$emit('toggle', this.$data.valueData)
                this.$emit('update:value', this.$data.valueData)
            }
        },
        computed: {
            inputName(){
                return this.name + '_toggle';
            }
        },
        watch: {
            valueData(val, old) {
                if (val !== old) {
                    this.$emit('toggle', val)
                }
            },
            value(val, old) {
                if (val !== old) {
                    this.$data.valueData = val
                }
            },
        },
    }
</script>

<style scoped>

</style>